import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBSouthProvinceFarmerLoans = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank signed a Memorandum of Understanding (MoU) with the Provincial Administration of Southern Province for the extension of loans to farmers in the province.</h1>


                    <p className="pb-3">During Day two of the Southern Province Expo 2025, our Managing Director, Mr. Brajesh Kumar Singh, participated in a panel discussion themed “Climate Smart Agriculture and Livestock Value Chain.”</p>

                    <p className="pb-3"><b>He articulated the Bank’s strategic vision for inclusive growth, stating:</b><br/>
                        <em style={{paddingTop: '10px', display: "block", fontSize: "16px", fontWeight: "400"}}>“In alignment with the Provincial Sustenance Strategy, Indo Zambia Bank is unlocking financial access for dairy farmers, fueling livelihoods, strengthening food security and driving inclusive economic growth across chiefdoms. The Bank is empowering rural dairy farmers through partnerships with Chiefdoms and Provincial Administrations, providing tailored financial solutions through the Indo Dairy Production and Development Finance Schemes and strengthening the dairy value chain by linking farmers to formal milk off-takers and processors. Through collaboration, training and local accountability, we are driving sustainable growth and demonstrating real impact with the successful Magoye launch, a testament to our commitment to farmer empowerment and rural prosperity.”</em></p>


                    <p className="pb-3">Following the panel discussion, our Managing Director signed a Memorandum of Understanding (MoU) with the Provincial Administration of Southern Province for the extension of loans to farmers in the province. The signing ceremony was witnessed by the Republican President, His Excellency Mr. Hakainde Hichilema.
                        Our Indo Dairy Production Loan and Indo Dairy Development Loan products are available across our nationwide branch network. For further details on eligibility and application procedures, please visit your nearest Indo Zambia Bank branch or contact our Customer Service Centre on 8002.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #SouthernExpo2025 #UnlockingInvestment #Partnership #Innovation #Livingstone #IZBFosteringGrowth</em></b></p>



                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-southern-province-mou-for-farmer-loans-banner-1.jpg" alt="Indo Zambia Bank signed a Memorandum of Understanding (MoU) with the Provincial Administration of Southern Province for the extension of loans to farmers in the province. Banner" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-southern-province-mou-for-farmer-loans-banner-2.jpg" alt="Indo Zambia Bank signed a Memorandum of Understanding (MoU) with the Provincial Administration of Southern Province for the extension of loans to farmers in the province. Banner" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-southern-province-mou-for-farmer-loans-banner-3.jpg" alt="Indo Zambia Bank signed a Memorandum of Understanding (MoU) with the Provincial Administration of Southern Province for the extension of loans to farmers in the province. Banner" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-southern-province-mou-for-farmer-loans-banner-4.jpg" alt="Indo Zambia Bank signed a Memorandum of Understanding (MoU) with the Provincial Administration of Southern Province for the extension of loans to farmers in the province. Banner" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-southern-province-mou-for-farmer-loans-banner-5.jpg" alt="Indo Zambia Bank signed a Memorandum of Understanding (MoU) with the Provincial Administration of Southern Province for the extension of loans to farmers in the province. Banner" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-southern-province-mou-for-farmer-loans-banner-6.jpg" alt="Indo Zambia Bank signed a Memorandum of Understanding (MoU) with the Provincial Administration of Southern Province for the extension of loans to farmers in the province. Banner" />
                            </div>
                        </Slider>
                    </div>
                </div>



            </section>

            <CustomerCare />
            <OurStores />

        </>
    );
};

export default IZBSouthProvinceFarmerLoans;
